import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";
import React from "react";
import LoadingSpinner from "../../Components/UI/LoadingSpinner";
import { usePlan } from "../../Context/PlanContext";
import { secondaryColor } from "../../Utils/Constant";

const featureCategories = {
  "Workspace & Forums & Users": [
    {
      label: "Max Create Workspace Count",
      value: "maxWorkSpaceCreateCount",
      type: "number",
    },
    {
      label: "Total Workspace Join",
      value: "maxWorkSpaceJoinCount",
      type: "number",
    },
    {
      label: "Max Create Forum Count",
      value: "maxCreateForumCount",
      type: "number",
    },
    // {
    //   label: "Max Add User Per Forum",
    //   value: "maxAddUserPerForum",
    //   type: "number",
    // },
  ],
  Storage: [
    { label: "Library Storage", value: "libraryStorage", type: "string" },
    { label: "Storage Options", value: "storageOption", type: "object" },
    { label: "Reference Storage", value: "referenceStorage", type: "string" },
  ],
  "Motion & Debates": [
    { label: "Suggest Motion", value: "suggestMotion", type: "boolean" },
    { label: "Find Motion", value: "findMotion", type: "boolean" },
    { label: "Max Citation Count", value: "numberofCitation", type: "number" },
    { label: "Access Save Debate", value: "accessSaveDebate", type: "boolean" },
    { label: "Access News", value: "accessNews", type: "boolean" },
    { label: "Private Debate", value: "privateDebate", type: "boolean" },
  ],
  Messaging: [
    { label: "Message", value: "messageOption", type: "boolean" },
    {
      label: "Create Group Message",
      value: "createGroupMessage",
      type: "boolean",
    },
  ],
  "AI & Admin Features": [
    { label: "AI Features", value: "aiAgent", type: "boolean" },
    { label: "Role Management", value: "roleManagement", type: "boolean" },
    { label: "Access Admin Panel", value: "accessAdminPanel", type: "boolean" },
  ],
};

const NewPlanTable = () => {
  const { defaultPlans } = usePlan();
  if (defaultPlans === undefined)
    return <LoadingSpinner color={secondaryColor} />;

  const headers = defaultPlans?.map((plan) => plan?.planName);

  const plans = Object.keys(defaultPlans);
  const data = Object.entries(featureCategories).map(
    ([category, features]) => ({
      category,
      features: features.map((feature) => ({
        name: feature.label,
        values: plans.map((plan) => defaultPlans[plan][feature.value]),
      })),
    })
  );

  return (
    <div className="overflow-x-auto p-8">
      <h2 className="text-2xl font-bold text-center mb-6">
        Compare Features Across Plans
      </h2>
      <table className="w-full border-collapse border border-gray-300 shadow-lg rounded-lg">
        <thead className="bg-gray-100 text-gray-900">
          <tr>
            <th className="border border-gray-300 px-4 py-2 text-left">
              Feature
            </th>
            {headers.map((plan) => (
              <th
                key={plan}
                className="border border-gray-300 px-4 py-2 text-center"
              >
                {plan}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white text-gray-900">
          {data.map(({ category, features }) => (
            <React.Fragment key={category}>
              <tr className="bg-gray-200">
                <td colSpan={plans.length + 1} className="font-bold px-4 py-2">
                  {category}
                </td>
              </tr>
              {features.map(({ name, values }, index) => (
                <tr key={index} className="border border-gray-300">
                  <td className="border border-gray-300 px-4 py-2 capitalize">
                    {name}
                  </td>
                  {values.map((value, i) => (
                    <td
                      key={i}
                      className="border border-gray-300 px-4 py-2 text-center"
                    >
                      {typeof value === "boolean" &&
                        name === "AI Features" &&
                        (value ? (
                          <span className="text-center text-AITheme-primary font-bold">
                            {" "}
                            Add-on{" "}
                          </span>
                        ) : (
                          <XMarkIcon className="text-red-500 w-full h-6" />
                        ))}
                      {typeof value === "boolean" &&
                        name !== "AI Features" &&
                        (value ? (
                          <CheckIcon className="text-green-500 w-full h-6 text-center" />
                        ) : (
                          <XMarkIcon className="text-red-500 w-full h-6" />
                        ))}
                      {(typeof value === "string" ||
                        typeof value === "number") && (
                        <span className="text-center">
                          {value
                            ? typeof value === "string"
                              ? value
                              : value > 100000
                              ? "Unlimited"
                              : value
                            : "-"}
                        </span>
                      )}
                      {typeof value === "object" && (
                        <span className="text-center capitalize">
                          {value?.map((item) => item).join(", ")}
                        </span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NewPlanTable;
